export function shallowEqualAndExclude(obj1, obj2, excludeList: string[]) {
    if (obj1 === obj2) {
        return false;
    }
    if (!obj1 || !obj2) {
        return obj1 !== obj2;
    }
    const keys1 = Object.keys(obj1),
        keys2 = Object.keys(obj2);
    if (keys1.length === keys2.length) {
        return !keys1.every(
            (key) => (obj2.hasOwnProperty(key) && obj1[key] === obj2[key]) || excludeList.includes(key)
        );
    }
    return true;
}
